/** Colunas do order by da pesquisa dos clientes */
export enum ClienteSearchOrderBy {
    CodigoIntegracaoErp = 1,
    Nome = 2,
    NomeFantasia = 3,
    CnpjCpf = 4,
    RepresentanteNome = 5,
    Situacao = 6,
    Cadastro = 7,
    Origem = 8,
    NomeCampanhaOrigem = 9,
    CanalMidiaSocial = 10,
    NomeCampanhaAquisicao = 11,
    TipoPessoa = 12,
    UpdatedAt = 13,
    GerenteNome = 14,
    AtendenteNome = 15
};
